import React from 'react'

const ExecutingLogout = () => {
	return <span>Closing session...</span>
}
export default ExecutingLogout